import { render, staticRenderFns } from "./LaudoBacenFiscalizacao.vue?vue&type=template&id=4ecf391a&scoped=true&lang=pug"
import script from "./LaudoBacenFiscalizacao.vue?vue&type=script&lang=js"
export * from "./LaudoBacenFiscalizacao.vue?vue&type=script&lang=js"
import style0 from "./LaudoBacenFiscalizacao.vue?vue&type=style&index=0&id=4ecf391a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecf391a",
  null
  
)

export default component.exports